import React, { FC } from 'react';
import { ReactComponent as SeaGull } from '../../../assets/images/SeaGull.svg';

interface EmptyNotificationProps {
  message: string;
}

export const EmptyNotification: FC<EmptyNotificationProps> = ({ message }) => {
  return (
    <div className="payment-history-page__content__empty">
      <SeaGull className="seagull" />
      <p>{message}</p>
    </div>
  );
};
